(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

  function handleDOMContentLoaded() {
    const playButtons = document.querySelectorAll('.media--video');
    playButtons.forEach((el) => el.addEventListener('click', handlePlayButton));
  }

  function handlePlayButton(e) {
    e.target.children[0].play();
    e.target.classList.add('media--played');
  }
})();
